module.exports = __webpack_public_path__ + "static/media/menu062023.aa6b518c.pdf";